import { formatNumber } from '@/lib/helpers';
import * as React from 'react';
import './index.scss';

export interface LiveProps {
  currentNumber: number;
  total: number;
}

export const Live: React.FC<LiveProps> = ({ currentNumber, total }) => (
  <div className="Live">
    <div className="Live__header">
      <span>Scopri tutti i risultati in tempo reale</span>
      <div className="Live__header__button">
        <span>Live</span>
      </div>
    </div>
    <div className="Live__progress">
      <div className="Live__progress__bar">
        <div
          style={{
            width: `${(currentNumber / total) * 100}%`,
          }}
        ></div>
      </div>
      <span>
        sezioni scrutinate: {formatNumber(currentNumber)} su{' '}
        {formatNumber(total)}
      </span>
    </div>
  </div>
);
